import { observable, action, runInAction } from "mobx";
import ReactGA from "react-ga";
import agent from "../agent";
import langStore from "./languageStore";
import { $util, $const } from "../helper";

const saveGameListToLocal = res => {
  const nowTime = Date.now();
  localStorage.setItem(
    $const.CACHE_REGISTRATION_CENTER_GAME_LIST,
    JSON.stringify({
      nowTime,
      res
    })
  );
};

class gameStore {
  @observable gameListV2 = [];
  @observable gameListV2currentPage = 1;
  @observable gameListV2totalPage = 1;
  @observable gameListV2HasMore = true;
  @observable _isGetGameListMoreLoading = false;
  @observable urlSpecificEvent = {};

  @observable gameDetailInfo = {};
  @observable showTerm = false;
  @observable gameLicense = "";
  @observable selectedGame = {};
  @observable gameRegistrationModal = false;
  @observable teamMemberMissingModal = false;
  @observable gameForm = undefined;
  @observable gameFormSuccessCallback = undefined;
  @observable gameRegistrationId = undefined;
  @observable submitButtonLoading = false;
  @observable currentGameId = undefined;
  @observable submitLimit = {
    show: false
  };
  // 备赛完成List
  @observable gameComplete = "";

  @observable countryList = [];
  @observable provinceList = [];
  @observable navAttr = {};

  @observable categories = [
    {
      id: "all",
      nameUuidI18n: {
        zh: "全部",
        en: "All"
      }
    }
  ];

  @observable v2categories = [];
  @observable v2categoriesObj = {};
  @observable license = "";
  @observable navState = {
    categoryId: "all",
    hostArea: "all",
    province: "all"
  };

  @observable selectNavState = {
    categoryId: "all",
    countryList: "all",
    provinceList: "all"
  };
  // 创建战队和修改战队资料页面展示介绍链接的赛事类型id
  @observable showIntroductionLinkGameCategoryId = undefined;
  // 创建战队和修改战队资料页面展示战队口号的赛事类型id
  @observable showTeamSloganGameCategoryId = [];

  @action filterGamesCategory(categoryId = "all") {
    this.navState = {
      hostArea: "all",
      province: "all",
      categoryId: categoryId
    };
    this.getGameListOnFilterChange();
  }

  @action filterGamesArea(hostArea = "all") {
    this.navState = {
      ...this.navState,
      hostArea: hostArea,
      province: "all"
    };
    this.getGameListOnFilterChange();
  }

  @action filterGamesProvince(province = "all") {
    this.navState = {
      ...this.navState,
      province: province
    };
    this.getGameListOnFilterChange();
  }

  @action getGameListOnFilterChange() {
    let hostArea = null;
    if (this.navState.hostArea !== "all") {
      hostArea = this.navState.hostArea;
    }
    if (this.navState.province !== "all") {
      hostArea = `${this.navState.hostArea}-${this.navState.province}`;
    }
    this.getGameList(
      this.navState.categoryId === "all" ? null : this.navState.categoryId,
      hostArea
    );
  }

  @action getUrlSpecificEvent(id) {
    const lang = langStore.lang;
    const PER_PAGE = 25;
    this.gameListV2currentPage = 1;
    this.gameListV2totalPage = 1;
    this.gameListV2HasMore = true;
    // 兼容报错
    if (id === "[object%20Object]") {
      return agent.Games.getV2Events(
        $util.beLangMap(lang),
        this.gameListV2currentPage,
        PER_PAGE,
        null,
        null
      ).then(res => {
        if (res && res.data) {
          runInAction(() => {
            this.gameListV2currentPage = res.data.current_page;
            this.gameListV2totalPage = res.data.total_pages;
            this.gameListV2.length = 0;
            this.gameListV2.push(...res.data.events);
            if (this.gameListV2currentPage >= this.gameListV2totalPage) {
              this.gameListV2HasMore = false;
            }
          });
        }
      });
    } else {
      return agent.Games.getV2Event(id, $util.beLangMap(lang)).then(res => {
        if (res && res.data) {
          runInAction(() => {
            this.urlSpecificEvent = res.data;
          });
        }
      });
    }
  }

  /*
   * 重置赛事列表，并获取赛事列表
   */
  @action async getGameList(category_id = null, host_area = null) {
    const lang = langStore.lang;
    const PER_PAGE = 25;
    const isInit = category_id === null && host_area === null;
    let hasLocalData = false;
    this.gameListV2currentPage = 1;
    this.gameListV2totalPage = 1;
    this.gameListV2HasMore = true;

    if (isInit) {
      /**
       * 初始化赛事列表，前端优化接口请求耗时严重。
       * 如果有本地缓存且缓存时间少于1min，那么使用缓存，并且也会请求服务端，更新本地缓存。
       */
      const localRes = JSON.parse(localStorage.getItem($const.CACHE_REGISTRATION_CENTER_GAME_LIST));
      const nowDate = Date.now();
      if (localRes && nowDate - localRes.nowTime < 1000 * 60 && localRes.res) {
        const res = localRes.res;
        runInAction(() => {
          this.gameListV2currentPage = res.data.current_page;
          this.gameListV2totalPage = res.data.total_pages;
          this.gameListV2.length = 0;
          this.gameListV2.push(...res.data.events);
          if (this.gameListV2currentPage >= this.gameListV2totalPage) {
            this.gameListV2HasMore = false;
          }
        });
        // 数据来自本地缓存埋点
        ReactGA.event({
          category: "perfTrack",
          action: "data",
          label: "cache"
        });
        hasLocalData = true;
        console.log("使用本地缓存");
        agent.Games.getV2Events(
          $util.beLangMap(lang),
          this.gameListV2currentPage,
          PER_PAGE,
          category_id,
          host_area
        ).then(res => {
          if (res && res.data) {
            saveGameListToLocal(res);
            console.log("本地缓存成功");
          }
        });
        return Promise.resolve();
      }
    }

    return agent.Games.getV2Events(
      $util.beLangMap(lang),
      this.gameListV2currentPage,
      PER_PAGE,
      category_id,
      host_area
    ).then(res => {
      if (res && res.data) {
        if (isInit) {
          saveGameListToLocal(res);
          if (hasLocalData) return;
          // 数据来自服务端埋点
          ReactGA.event({
            category: "perfTrack",
            action: "data",
            label: "server"
          });
        }
        runInAction(() => {
          this.gameListV2currentPage = res.data.current_page;
          this.gameListV2totalPage = res.data.total_pages;
          this.gameListV2.length = 0;
          this.gameListV2.push(...res.data.events);
          if (this.gameListV2currentPage >= this.gameListV2totalPage) {
            this.gameListV2HasMore = false;
          }
        });
      }
    });
  }

  /*
   * 加载更多赛事
   */
  @action getGameListMore() {
    // 如果加载中，那么等待加载完成，同一个时间只能有一个加载更多
    if (this._isGetGameListMoreLoading || !this.gameListV2HasMore) {
      return;
    }
    // 增加当前页码
    this.gameListV2currentPage++;

    this._isGetGameListMoreLoading = true;
    const lang = langStore.lang;
    const PER_PAGE = 25;

    let hostArea = null;
    if (this.navState.hostArea !== "all") {
      hostArea = this.navState.hostArea;
    }
    if (this.navState.province !== "all") {
      hostArea = `${this.navState.hostArea}-${this.navState.province}`;
    }
    return agent.Games.getV2Events(
      $util.beLangMap(lang),
      this.gameListV2currentPage,
      PER_PAGE,
      this.navState.categoryId === "all" ? null : this.navState.categoryId,
      hostArea
    ).then(res => {
      runInAction(() => {
        if (res && res.data) {
          this.gameListV2currentPage = res.data.current_page;
          this.gameListV2totalPage = res.data.total_pages;
          this.gameListV2.push(...res.data.events);
          this._isGetGameListMoreLoading = false;

          if (this.gameListV2currentPage >= this.gameListV2totalPage) {
            this.gameListV2HasMore = false;
          }
        }
      });
    });
  }

  /*
   * 获取赛事条款
   */
  @action getEventLicense(id) {
    const lang = langStore.lang;
    return agent.Games.getV2EventLicense(id, $util.beLangMap(lang)).then(res => {
      if (res && res.data) {
        this.license = res.data.license;
      }
    });
  }

  // 生成筛选器渲染数据
  @action filterGamesNavObj() {
    // “全部”筛选器的label
    const allConst = {
      value: "all",
      label: langStore.lang === "zh" ? "全部" : "All",
      enLabel: "All"
    };

    const allCountryList = [allConst];
    const allProvinceList = [allConst];
    this.v2categories.forEach(category => {
      const categoryCountryList = [allConst];
      const categoryProvinceList = [allConst];

      category.attributes.host_area &&
        category.attributes.host_area.forEach(area => {
          // 生成国家/地区筛选列表
          $util.getAreaOptions(langStore.lang).forEach(item => {
            if (area.includes(item.value)) {
              categoryCountryList.push(item);
              allCountryList.push(item);
            }
          });
          // 生成省份筛选列表
          $util.getAreaOptions(langStore.lang)[0].children.forEach(item => {
            if (area.includes(item.value)) {
              categoryProvinceList.push(item);
              allProvinceList.push(item);
            }
          });
        });
      category.countryList = this.sortBy(
        $util.getAreaOptions(langStore.lang),
        this.unique(categoryCountryList, "value")
      );
      category.provinceList = this.sortBy(
        $util.getAreaOptions(langStore.lang)[0].children,
        this.unique(categoryProvinceList, "value")
      );
    });
    // All选项的筛选
    this.v2categories.forEach(category => {
      if (category.id === "all") {
        category.countryList = this.sortBy(
          $util.getAreaOptions(langStore.lang),
          this.unique(allCountryList, "value")
        );
        category.provinceList = this.sortBy(
          $util.getAreaOptions(langStore.lang)[0].children,
          this.unique(allProvinceList, "value")
        );
      }
    });

    // 映射成对象
    this.v2categories.forEach(category => {
      this.v2categoriesObj[category.id] = category;
    });
  }

  //过滤出与url里eventId匹配的赛事所在的数组，deprecated
  @action filterUrlEventIdGameList(currentId = "all") {
    // 如果没有查到对应赛事，那么直接返回
    if (!Object.keys(this.urlSpecificEvent).length) {
      return;
    }

    // 找到赛事对应的类型id
    const eventCategoryId = this.urlSpecificEvent.attributes.category.id || "all";

    // 找到赛事对应语言下的名字
    const eventName = this.urlSpecificEvent.attributes.title || "all";

    // 找到赛事对应地区
    const eventArea = this.urlSpecificEvent.attributes.host_area || "all";
    const eventCountryList = eventArea === "all" ? "all" : [];
    const eventProvinceList = eventArea === "all" ? "all" : [];

    eventArea !== "all" &&
      eventArea.forEach(area => {
        $util.getAreaOptions(langStore.lang).forEach(item => {
          if (area.includes(item.value)) {
            eventCountryList.push(item);
          }
        });

        $util.getAreaOptions(langStore.lang)[0].children.forEach(item => {
          if (area.includes(item.value)) {
            eventProvinceList.push(item);
          }
        });
      });

    this.selectNavState.countryList =
      eventCountryList === "all"
        ? eventCountryList
        : eventCountryList.map(({ value, label, enLabel }) => ({
            value,
            label,
            enLabel
          }));
    this.selectNavState.provinceList = eventProvinceList;
    //当类型存在并且配置了对应语言
    this.selectNavState.categoryId =
      this.v2categoriesObj[eventCategoryId] && eventName ? eventCategoryId : "all";

    // 更新navState
    this.navState = {
      categoryId: this.selectNavState.categoryId ? this.selectNavState.categoryId + "" : "all",
      hostArea:
        this.selectNavState.countryList[0] && this.selectNavState.countryList[0].value
          ? this.selectNavState.countryList[0].value
          : "all",
      province:
        this.selectNavState.provinceList[0] && this.selectNavState.provinceList[0].value
          ? this.selectNavState.provinceList[0].value
          : "all"
    };

    let hostArea = null;
    if (this.navState.hostArea !== "all") {
      hostArea = this.navState.hostArea;
    }
    if (this.navState.province !== "all") {
      hostArea = `${this.navState.hostArea}-${this.navState.province}`;
    }
    this.getGameList(
      this.navState.categoryId === "all" ? null : this.navState.categoryId,
      hostArea
    );
  }

  /*
   * 重置filter为初始状态
   */
  @action resetNavState() {
    this.navState = {
      categoryId: "all",
      hostArea: "all",
      province: "all"
    };
  }

  /*
   * 获取category，增加一个名为all的类型，作为筛选器第一个级
   */
  @action getV2AllCategory() {
    const lang = langStore.lang;
    const categoryAll = {
      id: "all",
      attributes: {
        name: lang === "zh" ? "全部" : "All"
      }
    };
    return agent.Games.getV2Categories($util.beLangMap(lang)).then(
      action(res => {
        if (Array.isArray(res.data)) {
          // 只有比赛为“机甲大师高校人工智能挑战赛”时，可以让参赛队伍填写介绍链接
          this.showIntroductionLinkGameCategoryId = this.getSpecialCategoryId(res.data).id;
          // 只有比赛为“机甲大师高校联盟赛”和”机甲大师超级对抗赛“时，可以让参赛队伍填写队伍口号
          this.showTeamSloganGameCategoryId = this.getCategoryIdOfTeamSlogan(res.data);
          this.v2categories = this.unique([categoryAll, ...res.data], "id");
        }
      })
    );
  }

  @action getCategoryIdOfTeamSlogan = list => {
    return list
      .filter(item => {
        const { name } = item.attributes;
        return (
          name === "机甲大师高校联盟赛" ||
          name === "机甲大师超级对抗赛" ||
          name === "RoboMaster Robotics Competition" ||
          name === "RoboMaster Development League"
        );
      })
      .map(item => item.id);
  };

  @action getSpecialCategoryId = list => {
    return (
      list.find(item => {
        const { name } = item.attributes;
        return name === "机甲大师高校人工智能挑战赛" || name === "RoboMaster AI Challenge";
      }) || {}
    );
  };

  @action flattenMd(arr) {
    var result = [];
    function flatten(arr) {
      for (var i = 0; i < arr.length; i++) {
        if (Array.isArray(arr[i])) {
          flatten(arr[i]);
        } else {
          result.push(arr[i]);
        }
      }
    }
    flatten(arr);
    return result;
  }
  @action unique = (arr, attr) => {
    const res = new Map();
    return arr.filter(a => !res.has(a[attr]) && res.set(a[attr], 1));
  };
  @action sortBy = (standardList, dataList) => {
    let tmpArr = [];
    tmpArr.push(dataList[0]);
    standardList.forEach(standard => {
      dataList.forEach(data => {
        standard.value === data.value && tmpArr.push(data);
      });
    });
    return tmpArr;
  };

  /*
   * 设置当前已选择的赛事
   */
  @action setSelectedGame(id) {
    const lang = langStore.lang;
    return agent.Games.getV2Event(id, $util.beLangMap(lang)).then(res => {
      if (res && res.data) {
        runInAction(() => {
          this.selectedGame = res.data;
        });
      }
    });
  }

  @action showGameTerm(id, license, joinType) {
    // 展示条款
    this.gameListV2.forEach(game => {
      if (game.id === id) {
        this.selectedGame = game;
        // join a team 还是 apply
        this.selectedGame.joinType = joinType;
      }
    });
    this.gameLicense = license;
    this.showTerm = true;
  }

  @action closeGameTerm() {
    this.showTerm = false;
  }

  @action registration(registration) {
    return agent.Games.registration(registration).then(
      action(res => {
        if (
          res &&
          res.data &&
          res.data.createRegistration &&
          res.data.createRegistration.registration
        ) {
          this.gameRegistrationId = res.data.createRegistration.registration.id;
        }
      })
    );
  }

  @action async fetchJobDetail(id, jdIdentity) {
    return await agent.Recruit.fetchJobDetail(id, jdIdentity);
  }

  @action async getFilterItems() {
    return await agent.Recruit.getFilterItems();
  }

  @action async getPosition(params) {
    return await agent.Recruit.getPositionList(params);
  }

  @action formSubmit() {
    return agent.Recruit.submit(this.gameForm).then(
      action(res => {
        this.gameFormSuccessCallback();
        return res;
      })
    );
  }

  @action showGameRegistration() {
    this.gameRegistrationModal = true;
  }

  @action closeGameRegistration() {
    this.gameRegistrationModal = false;
  }

  @action showTeamMemberMissing() {
    this.teamMemberMissingModal = true;
  }

  @action closeTeamMemberMissing() {
    this.teamMemberMissingModal = false;
  }

  @action setGameForm(form, callBack) {
    this.gameForm = form;
    this.gameFormSuccessCallback = callBack;
  }

  @action setSubmitLimit(submitSum, limitSum, title, submitTimeReservation) {
    // 已提交次数 ，限制提交的次数， 环节名称
    this.submitLimit = {
      show: true,
      submitSum: submitSum,
      limitSum: limitSum,
      title: title,
      submitTimeReservation: submitTimeReservation
    };
  }

  @action clearSubmitLimit() {
    this.submitLimit = {
      show: false
    };
  }

  @action submitButtonStateLoading() {
    this.submitButtonLoading = true;
  }

  @action submitButtonStateNormal() {
    this.submitButtonLoading = false;
  }

  @action setGameFeedback(info) {
    this.gameComplete = info;
  }

  @action setCurrentGameId(id) {
    this.currentGameId = id;
  }

  @action clearCurrentGameId() {
    this.currentGameId = null;
    this.urlSpecificEvent = {};
  }
}

export default new gameStore();



// WEBPACK FOOTER //
// ./src/stores/gameStore.js